import { ItemTypeConsts } from 'client/util/Constants';

const CustomAppsAsidePanel = () => import('client/SoftwareApps/CustomAppsAsidePanel.vue');
const SoftwareAppsAsidePanel = () => import('client/SoftwareApps/SoftwareAppsAsidePanel.vue');
const SoftwareAppsMainPanel = () => import('client/SoftwareApps/SoftwareAppsMainPanel.vue');
const VppSoftwareAppsAsidePanel = () => import('client/SoftwareApps/VppSoftwareAppsAsidePanel.vue');

const softwareAppsProps = {
  asidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.softwareApps,
  },
  mainPanel: {
    gettingStartedPanelItemType: ItemTypeConsts.softwareApps,
    isAsideOpen: false,
    itemType: ItemTypeConsts.softwareApps,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const metaData = {
  title: 'Software Management',
  tooltipProps: {
    pText: '',
    showTooltip: false,
  },
};

export default [
  // Adding a redirect for backwards compatibility of any reference to
  // /managedSoftware in the admin portal.
  {
    path: '/managedSoftware',
    beforeEnter: (to, from, next) => {
      next({ path: '/managedSoftware/windows' });
    },
  },
  {
    path: '/managedSoftware/windows',
    name: 'softwareManagement',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
    },
    props: {
      mainPanel: {
        ...softwareAppsProps.mainPanel,
        initialTabIndex: 0,
      },
    },
  },
  {
    path: '/managedSoftware/apple',
    name: 'softwareManagementWindows',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
    },
    props: {
      mainPanel: {
        ...softwareAppsProps.mainPanel,
        initialTabIndex: 1,
      },
    },
  },
  {
    path: '/managedSoftware/google',
    name: 'softwareManagementGoogle',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
    },
    props: {
      mainPanel: {
        ...softwareAppsProps.mainPanel,
        initialTabIndex: 2,
      },
    },
  },
  {
    path: '/managedSoftware/windows/new',
    name: 'addManagedSoftware',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
      asidePanel: SoftwareAppsAsidePanel,
    },
    props: {
      mainPanel: softwareAppsProps.mainPanel,
      asidePanel: route => ({
        ...softwareAppsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/managedSoftware/apple/new',
    name: 'addVPPManagedSoftware',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
      asidePanel: CustomAppsAsidePanel,
    },
    props: {
      mainPanel: {
        ...softwareAppsProps.mainPanel,
        initialTabIndex: 1,
      },
      asidePanel: route => ({
        ...softwareAppsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/managedSoftware/google/new',
    name: 'addNewGoogleApp',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
    },
    props: {
      mainPanel: {
        ...softwareAppsProps.mainPanel,
        initialTabIndex: 2,
      },
    },
  },
  {
    path: '/managedSoftware/windows/:id/details',
    name: 'windowsSoftwareManagementDetails',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
      asidePanel: SoftwareAppsAsidePanel,
    },
    props: {
      mainPanel: {
        ...softwareAppsProps.mainPanel,
        initialTabIndex: 0,
      },
      asidePanel: route => ({
        ...softwareAppsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/managedSoftware/apple/:id/details',
    name: 'vppSoftwareManagementDetails',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
      asidePanel: VppSoftwareAppsAsidePanel,
    },
    props: {
      mainPanel: {
        ...softwareAppsProps.mainPanel,
        initialTabIndex: 1,
      },
      asidePanel: route => ({
        ...softwareAppsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/managedSoftware/custom/:id/details',
    name: 'appleSoftwareManagementDetails',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
      asidePanel: CustomAppsAsidePanel,
    },
    props: {
      mainPanel: {
        ...softwareAppsProps.mainPanel,
        initialTabIndex: 1,
      },
      asidePanel: route => ({
        ...softwareAppsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/managedSoftware/apple/:id/details/:initialTab',
    name: 'vppSoftwareManagementDetailsInitialTab',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
      asidePanel: VppSoftwareAppsAsidePanel,
    },
    props: {
      mainPanel: {
        ...softwareAppsProps.mainPanel,
        initialTabIndex: 1,
      },
      asidePanel: route => ({
        ...softwareAppsProps.asidePanel,
        itemId: route.params.id,
        navigateToTab: { tabLabel: route.params.initialTab },
      }),
    },
  },
  {
    path: '/managedSoftware/custom/:id/details/:initialTab',
    name: 'customSoftwareManagementDetailsInitialTab',
    meta: metaData,
    components: {
      mainPanel: SoftwareAppsMainPanel,
      asidePanel: CustomAppsAsidePanel,
    },
    props: {
      mainPanel: {
        ...softwareAppsProps.mainPanel,
        initialTabIndex: 1,
      },
      asidePanel: route => ({
        ...softwareAppsProps.asidePanel,
        itemId: route.params.id,
        navigateToTab: { tabLabel: route.params.initialTab },
      }),
    },
  },
];
